<template>
  <div class="gonggao">
    <p class="mode">
      <span>公示公告</span>
      <!-- <router-link to="/gongshigonggao" v-show="gsgg && gsgg.id">更多></router-link> -->
    </p>
    <div class="content">
      <h3>{{ gsgg && gsgg.title ? gsgg.title : '暂无公告' }}</h3>
      <p v-html="gsgg && gsgg.content ? gsgg.content : ''"></p>
      <router-link
        :to="{
          name: '公示公告详情',
          query: { id: gsgg && gsgg.id ? gsgg.id : '' },
        }"
        >{{ gsgg && gsgg.id ? '【详情】' : '' }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gsgg: {
        title: '',
      },
    }
  },
  created() {
    let url = 'gongshigonggao'
    // console.log('公示公告');
    // console.log(this.ajax_url(url));
    // console.log(this.ajax_url(url).data);
    this.gsgg = this.ajax_url(url).data
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.gonggao {
  /* margin-left: 20px; */
  width: 845px;
  margin-left: 10px;
  height: 500px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px 0 37px;
  width: 90%;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;
  margin: 0;
}

.mode > span {
  display: block;
  width: auto;
  height: 80px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 80px;
}

.content {
  display: block;
  padding: 30px;
  width: 95%;
  height: 305px;
  position: relative;
}

.content h3 {
  width: 95%;
  height: 75px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 39px;
  overflow: hidden;
  margin: 0;
}

.content p {
  text-indent: 2em;
  width: 90%;
  height: 200px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 49px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
}

.content a {
  width: auto;
  height: 24px;
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f55252;
  line-height: 24px;
  position: absolute;
  bottom: 30px;
  right: 36px;
}
</style>
